<template>
  <div>
    <b-card style="height:calc(100vh - 275px); overflow-y:auto;">
      <h4 class="text-left">Search Engine Configuration</h4>

      <b-row>
        <b-col cols="6" class="text-left">
          <b-form-group
            label="Select the media group (sites which you would to be searched against)"
          >
            <v-select
              :disabled="searchPage"
              :searchable="true"
              :clearable="true"
              label="text"
              @input="setcustomGoogleSearchEngineSites"
              v-model="customGoogleSearchEngineSite"
              :options="customGoogleSearchEngineSitesOptions"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="text-left">
            <!-- <b-form-checkbox
              :disabled="searchPage"
              @change="setGoogleValue"
              v-model="googleValue"
              value="1"
            >Google</b-form-checkbox>
            <b-form-checkbox
              :disabled="searchPage"
              @change="setBingValue"
              v-model="bingValue"
              value="1"
            >Bing</b-form-checkbox>-->
            <b-form-checkbox
              :disabled="searchPage"
              @change="setSortResultValue"
              v-model="sortResultValue"
              value="1"
            >Order by latest</b-form-checkbox>
            <b-form-checkbox
              :disabled="searchPage"
              @change="setExactPhraseMatchValue"
              v-model="exactPhraseMatchValue"
              value="1"
            >Exact Phrase Match</b-form-checkbox>
          </div>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Number of search results">
            <v-select
              :disabled="searchPage"
              :searchable="true"
              :clearable="true"
              label="text"
              @input="setNumberOfResults"
              v-model="numberOfResultsValue"
              :options="numberOfSearchResults"
            ></v-select>
          </b-form-group>
          <b-form-group label="Search engine language">
            <v-select
              :disabled="searchPage"
              :searchable="true"
              :clearable="true"
              label="text"
              code="id"
              @input="setLanguageValue"
              v-model="languageValue"
              :options="languageOptions"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { HTTP } from "../../../../utils/HTTP";
export default {
  name: "SearchEngineConfigurationComponent",
  data() {
    return {
      customGoogleSearchEngineSite: 0,
      googleValue: 1,
      bingValue: 1,
      sortResultValue: 1,
      exactPhraseMatchValue: 1,
      languageValue: { value: "lang_en", text: "English" },
      numberOfResultsValue: { value: 1, text: "10" },

      customGoogleSearchEngineSitesOptions: [
        { text: "All", value: 0 }
        // {text:'Global',value:1},
        // {text:'Regional',value:2},
        // {text:'Local',value:3},
        //  {text:'Newspaper Index',value:4},
      ],
      numberOfSearchResults: [
        { value: 1, text: "10" },
        { value: 2, text: "20" },
        { value: 3, text: "30" },
        { value: 4, text: "40" },
        { value: 5, text: "50" },
        { value: 6, text: "60" },
        { value: 7, text: "70" },
        { value: 8, text: "80" },
        { value: 9, text: "90" },
        { value: 10, text: "100" }
      ],
      languageOptions: [
        { value: "lang_en", text: "English" },
        { value: "lang_ar", text: "Arabic" },
        { value: "lang_bg", text: "Bulgarian" },
        { value: "lang_ca", text: "Catalan" },
        { value: "lang_cs", text: "Czech" },
        { value: "lang_hr", text: "Croatian" },
        { value: "lang_zh-CN", text: "Chinese (Simplified)" },
        { value: "lang_zh-TW", text: "Chinese (Traditional)" },
        { value: "lang_da", text: "Danish" },
        { value: "lang_nl", text: "Dutch" },
        { value: "lang_et", text: "Estonian" },
        { value: "lang_fr", text: "French" },
        { value: "lang_fi", text: "Finnish" },
        { value: "lang_de", text: "German" },
        { value: "lang_el", text: "Greek" },
        { value: "lang_hu", text: "Hungarian" },
        { value: "lang_iw", text: "Hebrew" },
        { value: "lang_id", text: "Indonesian" },
        { value: "lang_is", text: "Icelandic" },
        { value: "lang_it", text: "Italian" },
        { value: "lang_ja", text: "Japanese" },
        { value: "lang_ko", text: "Korean" },
        { value: "lang_lt", text: "Lithuanian" },
        { value: "lang_lv", text: "Latvian" },
        { value: "lang_no", text: "Norwegian" },
        { value: "lang_pl", text: "Polish" },
        { value: "lang_pt", text: "Portuguese" },
        { value: "lang_ro", text: "Romanian" },
        { value: "lang_ru", text: "Russian" },
        { value: "lang_sk", text: "Slovak" },
        { value: "lang_sl", text: "Slovenian" },
        { value: "lang_sr", text: "Serbian" },
        { value: "lang_es", text: "Spanish" },
        { value: "lang_sv", text: "Swedish" },
        { value: "lang_tr", text: "Turkish" }
      ]
    };
  },
  mounted() {
    if (this.negativeMediaEdit) {
      this.getDataNegativeMedia();
    }
    if (this.futureRisksEdit) {
      this.getDataFutureRisks();
    }
  },
  methods: {
    getDataNegativeMedia() {
      this.customGoogleSearchEngineSite = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].customGoogleSearchEngineSite;
      this.googleValue = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].google;
      this.bingValue = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].bing;
      this.sortResultValue = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].sortResult;
      this.exactPhraseMatchValue = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].exactPhraseMatch;
      this.languageValue = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].language;
      this.numberOfResultsValue = this.$store.state.priConfigrationforms.negativeMedia.categories[
        this.categoriesIndex
      ].numberOfResults;
    },
    getDataFutureRisks() {
      this.customGoogleSearchEngineSite = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].customGoogleSearchEngineSite;
      this.googleValue = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].google;
      this.bingValue = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].bing;
      this.sortResultValue = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].sortResult;
      this.exactPhraseMatchValue = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].exactPhraseMatch;
      this.languageValue = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].language;
      this.numberOfResultsValue = this.$store.state.priConfigrationforms.futureRisks.categories[
        this.categoriesIndex
      ].numberOfResults;
    },
    setcustomGoogleSearchEngineSites(value) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].customGoogleSearchEngineSite = value;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].customGoogleSearchEngineSite = value;
      }
    },
    // setGoogleValue(value) {
    //   if (this.futureRiskTab) {
    //     this.$store.state.priConfigrationforms.futureRisks.categories[
    //       this.categoriesIndex
    //     ].google = value;
    //   } else if (this.negativeMediaTab) {
    //     this.$store.state.priConfigrationforms.negativeMedia.categories[
    //       this.categoriesIndex
    //     ].google = value;
    //   }
    // },
    // setBingValue(value) {
    //   if (this.futureRiskTab) {
    //     this.$store.state.priConfigrationforms.futureRisks.categories[
    //       this.categoriesIndex
    //     ].bing = value;
    //   } else if (this.negativeMediaTab) {
    //     this.$store.state.priConfigrationforms.negativeMedia.categories[
    //       this.categoriesIndex
    //     ].bing = value;
    //   }
    // },
    setSortResultValue(value) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].sortResult = value;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].sortResult = value;
      }
    },
    setExactPhraseMatchValue(value) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].exactPhraseMatch = value;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].exactPhraseMatch = value;
      }
    },
    setLanguageValue(value) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].language = value;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].language = value;
      }
    },
    setNumberOfResults(value) {
      if (this.futureRiskTab) {
        this.$store.state.priConfigrationforms.futureRisks.categories[
          this.categoriesIndex
        ].numberOfResults = value;
      } else if (this.negativeMediaTab) {
        this.$store.state.priConfigrationforms.negativeMedia.categories[
          this.categoriesIndex
        ].numberOfResults = value;
      }
    }
  },
  props: {
    futureRiskTab: Boolean,
    negativeMediaTab: Boolean,
    categoriesIndex: Number,
    negativeMediaEdit: Boolean,
    futureRisksEdit: Boolean,
    searchPage: Boolean
  }
};
</script>